var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "checkout-item",
      attrs: { tabindex: "0", "aria-label": _vm.item.name + " for checkout" }
    },
    [
      !_vm.isMinified
        ? [
            _c("p", { staticClass: "is-size-6" }, [
              _c("strong", [_vm._v(_vm._s(_vm.item.name))]),
              _vm._v(" "),
              _c("span", { staticClass: "is-size-6 is-pulled-right amount" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      !_vm.isRecentOrder
                        ? _vm.itemPrice(_vm.index)
                        : _vm.getRecentOrderPrice()
                    ) +
                    "\n\t\t\t\t"
                )
              ])
            ]),
            _vm._l(_vm.getFlattenedDiscounts, function(discount) {
              return _c(
                "p",
                {
                  key: discount.id,
                  attrs: {
                    tabindex: "0",
                    "aria-label":
                      "discount applied to " +
                      _vm.item.name +
                      ": " +
                      discount.discountAmount
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\tDiscount (" +
                      _vm._s(discount.name) +
                      "):\n\t\t\t\t\t"
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "is-size-6 is-pulled-right amount discounted--amount"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t-" +
                          _vm._s(discount.discountAmount) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isDiscountOffer(discount)
                    ? [_c("offer-summary-item", { attrs: { offer: discount } })]
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _c("cart-item-info-siblings", {
              attrs: {
                options: _vm.item.options,
                isRecentOrder: _vm.isRecentOrder
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.bundleItems(), function(bundleItem) {
              return _c(
                "div",
                { key: _vm.bundleItemKey(bundleItem) },
                [
                  _c("h4", [_vm._v(_vm._s(bundleItem.name))]),
                  _vm._v(" "),
                  _c("cart-item-info-siblings", {
                    attrs: { options: bundleItem.options }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "item-quantity-actions",
                class: _vm.alignEditForBundle
              },
              [
                !_vm.isBundle
                  ? _c("BaseQuantityButtons", {
                      attrs: {
                        quantity: _vm.item.quantity,
                        settings: { item: _vm.item }
                      },
                      on: {
                        incrementQuantity: function($event) {
                          return _vm.increment()
                        },
                        decrementQuantity: function($event) {
                          return _vm.decrement()
                        },
                        setInputQuantity: _vm.setQuantityFromInput
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "edit--action",
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.editItem()
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.editItem()
                      }
                    }
                  },
                  [_vm._v("Edit")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { tabindex: "0" },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.removeItem()
                      }
                    }
                  },
                  [_vm._v("Delete")]
                )
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "is-size-6" },
                  [
                    _c("span", { staticClass: "has-text-grey" }, [
                      _vm._v(_vm._s(_vm.item.quantity))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "is-bold" }, [
                      _vm._v(_vm._s(_vm.item.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "is-size-6 is-pulled-right has-text-grey"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              !_vm.isRecentOrder
                                ? _vm.itemPrice(_vm.index)
                                : _vm.getRecentOrderPrice()
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.item.discounts, function(discount) {
                      return _c(
                        "p",
                        { key: discount.id },
                        [
                          _vm.showDiscount(discount)
                            ? [
                                _c("span", { staticClass: "is-size-6-5" }, [
                                  _vm._v(
                                    "Discount (" + _vm._s(discount.name) + "):"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "is-size-6 is-pulled-right amount discounted--amount"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t-" +
                                        _vm._s(_vm.displayDiscount(discount)) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isDiscountOffer(discount)
                                  ? [
                                      _c("offer-summary-item", {
                                        attrs: { offer: discount }
                                      })
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("cart-item-info-siblings", {
                  attrs: {
                    options: _vm.item.options,
                    isMinified: _vm.isMinified,
                    isRecentOrder: _vm.isRecentOrder
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.bundleItems(), function(bundleItem) {
                  return _c(
                    "div",
                    {
                      key: _vm.bundleItemKey(bundleItem),
                      staticClass: "indent"
                    },
                    [
                      _c("h4", [_vm._v(_vm._s(bundleItem.name))]),
                      _vm._v(" "),
                      _c("cart-item-info-siblings", {
                        attrs: {
                          options: bundleItem.options,
                          isMinified: _vm.isMinified
                        }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6c2a23c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6c2a23c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutItem.vue
// module id = null
// module chunks = 